import { PayloadAction } from "@reduxjs/toolkit";
import { InitialState, MenuListType } from "./Types";

export const Reducer = {
  /**
   * To set the tab list
   * @param state initial state value
   * @param action payload action
   */
  setTabListData: (state: InitialState, action: PayloadAction<MenuListType[]>): void => {
    state.tabList = action.payload;
  },

  /**
   * To set application key
   * @param state initial state
   * @param action payload action
   */
  setAplicationKey: (state: InitialState, action: PayloadAction<string>): void => {
    state.appKey = action.payload;
  },

  /**
   * To set the threshold limit
   * @param state initial state
   * @param action payload action
   */
  setThresholdLimit: (state: InitialState, action: PayloadAction<number>): void => {
    state.threshold = action.payload;
  }
};
